import { useState } from "react";

const PAGE_SIZE_STORAGE_KEY = "dataTablePageSize";
const DEFAULT_PAGE_SIZE = 20;

export const usePageSize = (initialPageSize: number = DEFAULT_PAGE_SIZE) => {
	const [pageSize, setPageSizeState] = useState<number>(() => {
		try {
			const stored = localStorage.getItem(PAGE_SIZE_STORAGE_KEY);
			if (stored) {
				const parsed = parseInt(stored, 10);
				if (!isNaN(parsed) && parsed > 0) {
					return parsed;
				}
			}
		} catch (error) {
			console.error("Error reading page size from localStorage:", error);
		}
		return initialPageSize;
	});

	const setPageSize = (newSize: number | ((prev: number) => number)) => {
		setPageSizeState((prev) => {
			const size =
				typeof newSize === "function" ? newSize(prev) : newSize;

			try {
				localStorage.setItem(PAGE_SIZE_STORAGE_KEY, size.toString());
			} catch (error) {
				console.error("Error saving page size to localStorage:", error);
			}

			return size;
		});
	};

	return [pageSize, setPageSize] as const;
};
